import { VoiceAgent } from '../components/voice-agent/VoiceAgent'
import { ProtectedRoute } from '../components/auth/ProtectedRoute'

export function VoiceAgentPage() {
  return (
    <ProtectedRoute>
      <VoiceAgent />
    </ProtectedRoute>
  )
}


